import Plausible from 'plausible-tracker'

const { trackPageview, trackEvent } = Plausible({
  domain: 'transloadit.com',
  trackLocalhost: false,
})

export { trackPageview, trackEvent }
